const t = /* @__PURE__ */ Symbol(
  "buttonGroupContextKey"
);
export {
  t as buttonGroupContextKey
};
